/*  ========================================================================
    # Main JavaScript
    ========================================================================  */

import PageStatus from './scripts/page-status';
import MobileMenu from './scripts/mobile-menu';
import MobileSubmenu from './scripts/mobile-submenu';
import OverlayHandling from './scripts/overlay-handling';
import Accordion from './scripts/accordion';
import ContactPersonsSlider from './scripts/contact-persons-slider';
import HeroVideoLightbox from './scripts/hero-video-lightbox';
import HistorySlider from './scripts/history-slider';
import HistoryTimeline from './scripts/history-timeline';
import IconListCollapse from './scripts/icon-list-collapse';
import JobFinder from './scripts/job-finder';
import ShareBar from './scripts/share-bar';
import SocialProof from './scripts/social-proof';
import TeaserSlider from './scripts/teaser-slider';
import VideoWithThumbnail from './scripts/video-with-thumbnail';

const scripts = [
  PageStatus,
  MobileMenu,
  MobileSubmenu,
  OverlayHandling,
  Accordion,
  ContactPersonsSlider,
  HeroVideoLightbox,
  HistorySlider,
  HistoryTimeline,
  IconListCollapse,
  JobFinder,
  ShareBar,
  SocialProof,
  TeaserSlider,
  VideoWithThumbnail
];

document.addEventListener('DOMContentLoaded', () => {
  if (scripts.length > 0 && scripts !== undefined) {
    scripts.forEach(script => {
      script.init();
    });
  }
});
